var U = {
  'checkItemsFromArrays': function(serach, array, ziduan) {
    let rlist = [];
    for (let i = 0; i < array.length; i++) {
      for (let z in ziduan) {
        if (array[i][ziduan[z]].indexOf(serach) != -1 ) {
          rlist.push(array[i]);break;
        }
      }
    }
    return rlist;
  }



};

export default U;



// WEBPACK FOOTER //
// ./src/utils/baseutil.js